import { FC, useState, useEffect } from "react";
import {
  JoinVideoCallInput,
  JoinVideoCalltMutationResponse,
  OnlineAppointmentProps,
} from "./OnlineAppointment.types";

import {
  Call,
  CallControls,
  LoadingIndicator,
  SpeakerLayout,
  StreamCall,
  StreamTheme,
  StreamVideo,
  StreamVideoClient,
  useCallStateHooks,
} from "@stream-io/video-react-sdk";

import { useMutation } from "@apollo/client";
import { JOIN_CALL_MUTATION } from "./OnlineAppointment.gql";
import "@stream-io/video-react-sdk/dist/css/styles.css";
import { ErrorBoundary } from "@sentry/react";

const apiKey = "tdpayzbvfxgw";

const OnlineAppointment: FC<OnlineAppointmentProps> = ({
  useParams,
  useNavigate,
  user,
}) => {
  const { appointment: appointmentId } = useParams<{ appointment: string }>();
  const navigate = useNavigate();

  const [getToken, { loading: loadingGetToken }] = useMutation<
    JoinVideoCalltMutationResponse,
    JoinVideoCallInput
  >(JOIN_CALL_MUTATION, {
    onError: (error) => {
      console.log(error);
    },
  });

  const [client, setClient] = useState<StreamVideoClient | null>(null);
  const [call, setCall] = useState<Call | null>(null);
  const [token, setToken] = useState<string>();
  const [isCallJoined, setIsCallJoined] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const joinVideoCall = async () => {
    if (!appointmentId) return;

    if (isCallJoined) {
      console.log("Already joined the call");
      return;
    }

    const response = await getToken({
      variables: {
        input: {
          appointmentId,
          role: "doctor",
        },
      },
    });

    if (response?.data?.joinVideoCall) {
      const { success, data, message } = response.data.joinVideoCall;
      if (success) {
        setToken(data);

        try {
          const newClient = new StreamVideoClient({
            apiKey,
            user: {
              id: user.id,
            },
            token: data,
          });
          setClient(newClient);
          const newCall = newClient.call("default", appointmentId);
          await newCall.join({ create: false });
          setCall(newCall);
          setIsCallJoined(true);
        } catch (error) {
          console.log(error);
        }
      } else {
        console.log(message);
      }
    } else {
      console.log("error");
    }
  };

  useEffect(() => {
    joinVideoCall();
  }, []);

  useEffect(() => {
    return () => {
      try {
        if (isCallJoined) {
          call?.leave();
        } else if (!loaded) {
          setLoaded(true);
        } else {
          navigate(`/logs/appointment/${appointmentId}`);
        }
      } catch (error) {
        console.log("Already left call");
      }
    };
  }, [isCallJoined]);

  // useEffect(() => {
  //   const clientInstance = new StreamVideoClient({ apiKey, user, token });
  //   setClient(clientInstance);

  //   const callInstance = clientInstance.call(
  //     "default",
  //     "6bb902b9-8222-4c42-83f9-2905483cd05b"
  //   );
  //   callInstance.join({ create: false });
  //   setCall(callInstance);
  // }, []);

  if (!client || !call) return <LoadingIndicator />;

  return (
    <ErrorBoundary
      onError={(error) => {
        console.log(error);
      }}
    >
      <StreamVideo client={client}>
        <StreamTheme>
          <StreamCall call={call}>
            <VideoUI
              onLeave={() => {
                setIsCallJoined(false);
                navigate(`/logs/appointment/${appointmentId}`);
              }}
            />
          </StreamCall>
        </StreamTheme>
      </StreamVideo>
    </ErrorBoundary>
  );
};

const VideoUI: FC<{ onLeave: () => void }> = ({ onLeave }) => {
  const { useLocalParticipant } = useCallStateHooks();
  const localParticipant = useLocalParticipant();

  return (
    <>
      <SpeakerLayout participantsBarLimit={1} />
      <CallControls onLeave={onLeave} />
      {/* {doctor && <ParticipantView participant={doctor} />}
      {patient && <ParticipantView participant={patient} />} */}
    </>
  );
};

export const MyVideoButton = () => {
  const { useCameraState } = useCallStateHooks();
  const { camera, isMute } = useCameraState();
  return (
    <button onClick={() => camera.toggle()}>
      {isMute ? "Turn on camera" : "Turn off camera"}
    </button>
  );
};

export const MyMicrophoneButton = () => {
  const { useMicrophoneState } = useCallStateHooks();
  const { microphone, isMute } = useMicrophoneState();
  return (
    <button onClick={() => microphone.toggle()}>
      {isMute ? "Turn on microphone" : "Turn off microphone"}
    </button>
  );
};

export default OnlineAppointment;
